import React from 'react';
import { Link } from 'react-router-dom';
import enhance from './enhance';
import NavLinks from '../NavLinks';
import styles from './styles.scss';
import arrowUp from './arrow-up.svg';
import arrowDown from './arrow-down.svg';
import helpCenterIcon from './menu-help-center.svg';
import settingIcon from './menu-settings.svg';

export const Header = ({
  dealerName,
  displayPopUpHelpPage,
  helpCenter,
  isOpen,
  mini,
  setElementRef,
  settings,
  toggleOpen,
}) => (
  <div className={mini ? styles.miniContainer : styles.container}>
    {isOpen ? (
      <div className={styles.dealerNameContainer} ref={setElementRef}>
        <div onClick={toggleOpen}>
          <span>{dealerName}</span> <img alt="arrow-up" src={arrowUp} />
        </div>
        <div className={styles.dropdown}>
          <Link to="/user-setting" className={styles.link}>
            <img alt="settings" src={settingIcon} /> <span>{settings}</span>
          </Link>
          <div className={styles.link} onClick={displayPopUpHelpPage}>
            <img alt="help-center" src={helpCenterIcon} />{' '}
            <span>{helpCenter}</span>
          </div>
        </div>
      </div>
    ) : (
      <div onClick={toggleOpen} className={styles.dealerNameContainer}>
        <span>{dealerName}</span> <img alt="arrow-down" src={arrowDown} />
      </div>
    )}

    <NavLinks />
  </div>
);

export default enhance(Header);
